import type { ReactNode } from 'react';

import classNames from 'classnames';

import * as styles from './EditorSelectableField.css';

interface Props {
  children: ReactNode;
  selected?: boolean;
  dataAttribute: 'data-web-header-title' | 'data-web-header-subtitle';
}

export const EditorSelectableField = ({ children, selected, dataAttribute }: Props) => {
  return (
    <div className={classNames(styles.selectable, selected && styles.selected)} {...{ [dataAttribute]: 'true' }}>
      {children}
    </div>
  );
};
